import { Chip } from "@/components/control-tower/Chip";
import {
  ENTITY_KINDS,
  ENTITY_KIND_LABEL_FI,
  type EntityKind,
} from "@/lib/entity-kind";

// The one shared entity-kind chip row for Tapahtumaloki / Havainnot / Suositukset
// (docs/spec/concepts.md § Shared entity-kind filter, story #964/#969) — built once, reused
// on all three portfolio Toiminnot rather than a bespoke filter per route. Props are entity-kind
// values only; this control never accepts a `PerspectiveId`.
export interface EntityKindFilterProps {
  active: EntityKind | "all";
  onChange: (kind: EntityKind | "all") => void;
}

export function EntityKindFilter({ active, onChange }: EntityKindFilterProps) {
  return (
    <div className="flex flex-wrap items-center gap-1">
      <Chip
        active={active === "all"}
        label="Kaikki"
        onClick={() => onChange("all")}
      />
      {ENTITY_KINDS.map((kind) => (
        <Chip
          key={kind}
          active={active === kind}
          label={ENTITY_KIND_LABEL_FI[kind]}
          onClick={() => onChange(kind)}
        />
      ))}
    </div>
  );
}
